<template>
  <div class="user-center">
    <div class="user-center-wrapper">
      <div class="user-info">
        <el-row type="flex" align="middle">
          <el-col :span="8">
            <img width="128" height="128" class="avatar" src="https://img1.wxzxzj.com/vued330320dd9a1ba1221aa97e5929182fbd.png" alt="">
          </el-col>
          <el-col :span="16">
            <p class="user-name">{{accountInfo.account}}</p>
            <p>上次登录时间：{{accountInfo.lastLoginTime? accountInfo.lastLoginTime : '无'}}</p>
            <p>总登录次数：{{accountInfo.loginCount? accountInfo.loginCount : '无'}}</p>
          </el-col>
        </el-row>
      </div>
      <router-view class="router-view" />
      <el-button
        @click="backCenter()"
        class="back-center">返回
      </el-button>
    </div>
  </div>
</template>

<script>
import { Row, Col } from 'element-ui';
// import api from '@/api/graphql/account';

export default {
  components: {
    ElRow: Row,
    ElCol: Col,
  },
  data() {
    return {
      accountInfo: {},
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      // api.getAccount().then((data) => {
      //   this.accountInfo = data.account;
      // });
    },
    backCenter() {
      this.$router.push({ path: '/learning-center/course/' });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .user-center {
    height: 100%;
    overflow-y: auto;
    .user-center-wrapper {
      width: $content-width-medium;
      background-color: #fff;
      margin: 60px auto;
      padding: 20px;
      position: relative;
      .user-info {
        .user-name {
          font-weight: bold;
          font-size: 30px;
        }
        .avatar {
          display: block;
          margin: 30px auto 0;
        }
        p {
          font-size: 16px;
        }
      }
      .router-view {
        margin-top: 20px;
      }
      .back-center {
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }
  }
</style>
